import { render, staticRenderFns } from "./screent_left.vue?vue&type=template&id=057ed032&scoped=true"
import script from "./screent_left.vue?vue&type=script&lang=js"
export * from "./screent_left.vue?vue&type=script&lang=js"
import style0 from "./screent_left.vue?vue&type=style&index=0&id=057ed032&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "057ed032",
  null
  
)

export default component.exports